// const log = global.log.getLogger("f_mtac.scene.interactions.group");

const Group = function Group({name, enable, disable, data, interactions}) {
    let enabled = false;

    Object.defineProperty(this, "enabled", {
        set: () => {},
        get: () => enabled
    });

    Object.defineProperty(this, "name", {
        set: () => {},
        get: () => name
    });

    this.enable = () => {
        if (!enabled) {
            for (let interaction of interactions) {
                interaction.enable();
            }
            enable(data);
            enabled = true;
        }
    };

    this.disable = () => {
        if (enabled) {
            for (let interaction of interactions) {
                interaction.disable();
            }
            disable(data);
            enabled = false;
        }
    };

    this.add_interaction = (interaction) => {
        interactions.push(interaction);
    };
};

export default Group;
